import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { CONTACTS } from "@/content";
import PageBackground from "./PageBackground";

const SECTIONS = [
    {
        title: "1. Titolare del trattamento",
        body: `Il titolare del trattamento dei dati personali è Gianluca Capri, con residenza in ${CONTACTS.address}, raggiungibile all'indirizzo email ${CONTACTS.email} o al telefono ${CONTACTS.phoneDisplay}.`,
    },
    {
        title: "2. Dati raccolti",
        body: "Attraverso il modulo contatti di questo sito vengono raccolti: nome e cognome, azienda, indirizzo email, numero di telefono (facoltativo), tipo di esigenza selezionato e contenuto del messaggio inviato. Durante la navigazione possono inoltre essere raccolti dati tecnici anonimi di utilizzo del sito.",
    },
    {
        title: "3. Finalità e base giuridica",
        body: "I dati forniti vengono utilizzati esclusivamente per rispondere alla richiesta inviata e per essere ricontattato in vista di una prima conversazione conoscitiva. La base giuridica del trattamento è l'esecuzione di misure precontrattuali adottate su richiesta dell'interessato (art. 6, paragrafo 1, lettera b del GDPR). Il conferimento è facoltativo, ma necessario per poter essere ricontattato.",
    },
    {
        title: "4. Modalità di trattamento e conservazione",
        body: "I dati sono trattati con strumenti informatici e misure di sicurezza adeguate, conservati su sistemi protetti e trasmessi al titolare anche tramite posta elettronica. Vengono conservati per il tempo necessario a gestire la richiesta e comunque non oltre 24 mesi dall'ultimo contatto.",
    },
    {
        title: "5. Comunicazione a terzi",
        body: "I dati non vengono ceduti, venduti o comunicati a terzi per finalità proprie, salvo obblighi di legge. Possono essere trattati da fornitori tecnici (hosting, servizio di invio email) che operano nel rispetto del GDPR.",
    },
    {
        title: "6. Diritti dell'interessato",
        body: `Ai sensi degli articoli 15-22 del GDPR puoi esercitare in qualsiasi momento i diritti di accesso, rettifica, cancellazione, limitazione del trattamento, opposizione e portabilità dei dati scrivendo a ${CONTACTS.email}. Hai inoltre diritto di proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).`,
    },
    {
        title: "7. Cookie",
        body: "Questo sito non utilizza cookie di profilazione propri né strumenti di tracciamento pubblicitario.",
    },
];

export default function Privacy() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen">
            <PageBackground />
            <header className="relative z-10 border-b border-navy-600/70">
                <div className="mx-auto flex h-[72px] max-w-4xl items-center justify-between px-6">
                    <a href="/" data-testid="privacy-logo" className="font-display text-xl font-semibold tracking-tight text-slate-50">
                        GC<span className="text-sky-400">.</span>
                    </a>
                    <a
                        href="/"
                        data-testid="privacy-back-link"
                        className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-slate-400 transition-colors hover:text-sky-400"
                    >
                        <ArrowLeft className="h-4 w-4" />
                        Torna al sito
                    </a>
                </div>
            </header>

            <main className="relative z-10 mx-auto max-w-4xl px-6 py-16 lg:py-24" data-testid="privacy-page">
                <p className="font-mono text-xs font-semibold uppercase tracking-[0.3em] text-sky-400">Documento legale</p>
                <h1 className="mt-4 font-display text-3xl font-semibold tracking-tight text-slate-50 sm:text-4xl lg:text-5xl">
                    Informativa Privacy
                </h1>
                <p className="mt-4 text-sm text-slate-500">
                    Ultimo aggiornamento: settembre 2026 · ai sensi del Regolamento (UE) 2016/679 ("GDPR")
                </p>

                <div className="mt-12 space-y-10">
                    {SECTIONS.map((s) => (
                        <section key={s.title} data-testid={`privacy-section-${s.title.split(".")[0]}`}>
                            <h2 className="font-display text-xl font-semibold text-slate-50">{s.title}</h2>
                            <p className="mt-3 text-sm leading-relaxed text-slate-400 sm:text-base">{s.body}</p>
                        </section>
                    ))}
                </div>
            </main>

            <footer className="relative z-10 border-t border-navy-600/70 py-8 text-center font-mono text-[11px] text-slate-600">
                © 2026 Gianluca Capri — Tutti i diritti riservati
            </footer>
        </div>
    );
}
